import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { customersDataHe, customersDataEn, customersData } from '../customersDataFile';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { Subscription } from 'rxjs';
import { Language } from 'app/shared/model/enums';

@Component({
  selector: 'app-customers-telling',
  templateUrl: './customers-telling.component.html',
  styleUrls: ['./customers-telling.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class CustomersTellingComponent implements OnInit {
  customers: customersData[];
  @Input() startFromSecond: boolean ;
  subscriptions = new Subscription();
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  constructor(store: Store<AppState>,private cdr: ChangeDetectorRef) {
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.loadData(language);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {

  }
  get displayedCustomers(): customersData[] {
    if (this.startFromSecond && this.customers.length > 1) {
      let swappedArray = [...this.customers];
      [swappedArray[0], swappedArray[1]] = [swappedArray[1], swappedArray[0]];
      return swappedArray;
    }
    return this.customers;
  }
  loadData(language: Language) {
    let map = new Map<Language, customersData[]>();
    map.set(Language.en, customersDataEn);
    map.set(Language.he, customersDataHe);
    map.set(Language.bg, customersDataEn);
   
    this.customers = [];
    setTimeout(() => {
      this.customers = map.get(language);
    
      this.cdr.markForCheck()      
    }, 10);
  }
}